import QuotationComponent from "../../assets/components/06_quotation_component/quotation_component";
import Header from "../../assets/components/01_header/header"
import Footer from "../../assets/components/02_footer/footer"
import { HelmetProvider } from 'react-helmet-async';
export default function Quotation() {
    return (
        <div>
            <HelmetProvider>
                <title>Request Custom Digital Marketing Solutions in Mumbai</title>
                <meta name="Request a quote from Adstrate, a digital marketing agency in Mumbai offering social media marketing in Mumbai, Instagram marketing agency services, and content creation solutions." />
                <link rel="canonical" href="https://adstrate.in/quotation" />
            </HelmetProvider>
            <Header />
            <QuotationComponent />
            <Footer />
        </div>
    );
}